<template>
    <div>
        <b-card card-title="Details">
            <b-form class="usersForm" v-if="show_form">
                <b-row>
                    <b-col cols="8">
                        <b-row>
                            <b-col cols="6">
                                <b-form-group id="name" label="Name" label-for="name-input">
                                    <b-form-input id="name-input" v-model="form.name" type="text" placeholder="Enter name" required></b-form-input>
                                </b-form-group>
                            </b-col>

                            <b-col cols="6">
                                <b-form-group id="email" label="Email" label-for="email-input">
                                    <b-form-input id="email-input" v-model="form.email" type="email" placeholder="Enter email" required></b-form-input>
                                </b-form-group>
                            </b-col>

                        </b-row>
                        <!-- --------------------- -->
                        <b-row>
                            <b-col cols="4">
                                <b-form-group id="cell_no" label="Cell No" label-for="number-input">
                                    <b-form-input id="number-input" v-model="form.cell_no" type="number" placeholder="Enter cell number" required></b-form-input>
                                </b-form-group>
                            </b-col>

                            <b-col cols="4">
                                <b-form-group id="id_number" label="ID Number" label-for="id-input">
                                    <b-form-input id="id-input" v-model="form.id_number" type="number" placeholder="ID number" required></b-form-input>
                                </b-form-group>
                            </b-col>

                            <b-col cols="4">
                                <b-form-group id="years_experience" label="Years Experience" label-for="years_experience-input">
                                    <b-form-input id="years_experience-input" v-model="form.years_experience" type="number" placeholder="Enter years of experience" required></b-form-input>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="4">
                        <b-form-group id="years_experience" label="Profile Picture" label-for="profile-pic">
                            <b-card style="height: 6.2rem; " class="border border-light mb-0">
                                <b-img src="@/assets/user.png"></b-img>
                            </b-card>
                        </b-form-group>
                    </b-col>
                </b-row>
                <!-- --------------------- -->
                <b-row>
                    <b-col cols="12">
                        <b-form-group id="academic_qualifications" label="Academic Qualifications" label-for="academic_qualifications-input">
                            <b-form-textarea id="academic_qualifications-input" v-model="form.academic_qualifications" type="phone" placeholder="Enter academic qualifications" required></b-form-textarea>
                        </b-form-group>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col cols="12">
                        <b-form-group id="designation" label="Designation" label-for="designation-input">
                            <b-form-textarea id="designation-input" v-model="form.designation" type="text" placeholder="Designation description" required></b-form-textarea>
                        </b-form-group>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col cols="12">
                        <b-form-group id="work_qualifications" label="Work Qualifications" label-for="work_qualifications-input">
                            <b-form-textarea id="work_qualifications-input" v-model="form.work_qualifications" type="text" placeholder="Enter work qualifications" required></b-form-textarea>
                        </b-form-group>
                    </b-col>
                </b-row>
                <hr>
                <b-row>
                    <b-form-group id="documents" label="Download Documents" label-for="documents">
                        <b-button @click="downloadDoc('all')" :disabled="hasData('all')" variant="success" size="lg">Download All</b-button>&nbsp;
                        <b-button @click="downloadDoc('id_copy')" :disabled="hasData('id_copy_s3_src')" variant="primary" size="lg">ID Copy {{form.id_copy_s3_src}}</b-button>&nbsp;
                        <b-button @click="downloadDoc('police_clearance')" :disabled="hasData('police_clearance_s3_src')" variant="primary" size="lg">Police Clearance</b-button>&nbsp;
                        <b-button @click="downloadDoc('letter_of_appointment')" :disabled="hasData('letter_of_appointment_s3_src')" variant="primary" size="lg">Letter of Appointment</b-button>&nbsp;
                        <b-button @click="downloadDoc('letter_of_acceptance')" :disabled="hasData('letter_of_acceptance_s3_src')" variant="primary" size="lg">Letter of Acceptance</b-button>&nbsp;
                        <b-button @click="downloadDoc('job_description')" :disabled="hasData('job_desc_s3_src')" variant="primary" size="lg">Job Description</b-button>&nbsp;
                    </b-form-group>
                </b-row>
            </b-form>
            <b-alert :show="show_form == false">Loading...</b-alert>
        </b-card>
    </div>
</template>

<script>
import _ from 'lodash'
import { clientAdminState, clientAdminMethods } from '@/state/helpers'
export default {
    data:() => ({
        show_form: false,
        form:{
            id: '',
            name: '',
            cell_no: '',
            email: '',
            designation: '',
            id_number: '',
            academic_qualifications: '',
            work_qualifications: '',
            years_experience: '',
            password: '',
        }
    }),
    computed:{
        ...clientAdminState,
    },
    methods:{
        ...clientAdminMethods,
        downloadDoc(type){
            if(type === 'all'){
                let params = {
                    jwt: window.localStorage.getItem('x_token'),
                    user_id: this.form.id,
                };
                this.downloadPersonnelDocuments(params)
                .then( response => {
                    console.log('RESPONSE: ', response);
                })
            }
            else{
                let params = {
                    type: type,
                    jwt: window.localStorage.getItem('x_token'),
                    user_id: this.form.id,
                };
                this.downloadPersonnelDocument(params)
                .then( response => {
                    console.log('RESPONSE: ', response);
                })
            }
        },
        hasData(type){
            let disabled = true;
            if(type === 'all'){
                if(
                    this.form.id_copy_s3_src != null &&
                    this.form.job_desc_s3_src != null &&
                    this.form.police_clearance_s3_src != null &&
                    this.form.letter_of_acceptance_s3_src != null &&
                    this.form.letter_of_appointment_s3_src!= null
                ){
                    disabled = false;
                }
            }
            else if(this.form[type] != null){
                disabled = false;
            }

            return disabled;

        }
    },
    mounted(){
        this.getLoggedInUserProfile()
        .then(()=>{
            this.form = _.cloneDeep(this.user_profile);
            this.show_form = true;
        })
    },
}
</script>

<style>
.usersForm > .row{
    padding-bottom: 0.9rem;
}
.usersForm > .row > div > .row{
    padding-bottom: 0.9rem;
}
</style>